import { Button, Input, Modal, Select } from "antd";
import React from "react";

const EditModal = (props) => {
    const {showEdit, setShowEdit} = props;
    return <>
              <Modal visible={showEdit} footer={null} onCancel={()=>setShowEdit(false)} className="memberset_edit">
            <div className="confirm_wrap">
              <div className="details_head">
                <div className="img_sec">
                <img src="/images/user.png" alt="user" height="50px" />
                </div>
                <div className="user_info">
                  <div className="name">Esther Howard</div>
                  <div className="email">Estherhoward@gmail.com</div>
                </div>
              </div>
              <div className="content">
                <div>Select role</div>
                <Select placeholder="select role from here" />
              </div>
              <div className="content">
                <label>Old Password</label>
                <Input placeholder="Enter old password here" />
              </div>
              <div className="content">
                <label>New Password</label>
                <Input placeholder="Enter new password here" />
              </div>
              <div className="btn_section">
                    <Button type="primary" className='field_save_btn' style={{ width:"200px", height: "35px" }}>Save</Button>
              </div>
            </div>
          </Modal></>
};
 export default EditModal;